import moment from 'moment';
/**
 * @description   두 날짜 사이의 날짜 배열로 반환하는 함수. 
 * ex) startDate = 2019.01.01 / endDate = 2019.05.01 -> [2019.01.01, 2019.02.01 , 2019.03.01, 2019.04.01, 2019.05.01]
 * @param {Date} startDate 
 * @param {Date} endDate 
 * @param {String} dateType 두 날짜 사이의 가져올 기준 값. ex) month, year, day
 * @return {Array} startDate~endDate사이 월별/연도별 날짜-date type으로- 배열
 */
export function getArraysBetweenTwoDates (startDate, endDate, dateType){
  let resultDateList = [];
  let todayDate = moment(endDate).startOf(dateType);

  //현재 날짜하고 마지막으로 데이터 입력된 날짜와의 차이
  const differentdate = todayDate.diff(startDate, dateType);

  for (var i = 0; i < differentdate; i++){
    startDate = moment(startDate).add(1,dateType);
    resultDateList.push(startDate.clone().toDate());
  }

  //중복 제거
  resultDateList = [...new Set(resultDateList)];
  // resultDateList.reverse();
  return resultDateList;
}
